module.exports = __webpack_public_path__ + "e7eb89c8b786e8155975d59f701e946b.fbx";